//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { formatDate, convertDuration } from '@/helpers/filters.js';
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  props: ['resource', 'items'],
  data() {
    return {
      favorite: false,
    };
  },
  computed: {
    isResourseFavourited() {
      return this.isFavoriteResource(this.resource.type, this.resource.id);
    },
  },
  methods: {
    formatDate,
    convertDuration,
    toggleFavo() {
      if (!this.$auth.loggedIn) {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message =
          'Je kan alleen favorieten toevoegen als je bent ingelogd.';
        return this.$store.commit('alertStore/setAlert', alertObj);
      }
      let data = {
        resource_id: this.resource.id,
        subscribe: this.isResourseFavourited ? 0 : 1,
      };
      this.$store.dispatch('accountStore/toggleFavorite', data);
    },
  },
};
